// extracted by mini-css-extract-plugin
export default {"tabsBlock":"TabBar_tabsBlock__sHauK","tabItem":"TabBar_tabItem__X2xVh","active":"TabBar_active__+74Sf"};